import { Component, Inject, AfterViewInit } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { SnackBarService } from "../../service/snack.bar.service";
import { GetAddEventLeadLinkGQL } from "../../../../generated/graphql";

export interface DialogData {
  campaignId: any;
  eventId: string;
  eventData: any;
  userId: any;
}

@Component({
  selector: "add-event-lead-dialog",
  templateUrl: "./add-event-lead-dialog.html",
  styleUrls: [],
})
export class AddEventLeadDialog implements AfterViewInit {
  link: string;
  campaignId: string;
  campaignLink: any;
  eventDetails: any;
  eventId: any;
  accountId: any;
  userId: any;

  constructor(
    public dialogRef: MatDialogRef<AddEventLeadDialog>,
    private getAddEventLeadLink: GetAddEventLeadLinkGQL,
    private snackBarService: SnackBarService,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {
    this.campaignId = this.data.campaignId;
    this.eventId = this.data.eventData.id
    this.accountId = this.data.eventData.accountId
    this.userId = this.data.userId;
    this.generateQRCode();
  }

  ngAfterViewInit() { }

  private generateQRCode() {
    this.getAddEventLeadLink
      .fetch({
        campaignId: this.campaignId,
        eventId: this.eventId,
        accountId: this.accountId,
        userId: this.userId,
      })
      .subscribe((result) => {
        if (result?.errors) {
          this.snackBarService.showQueryError(result.errors);
        }
        this.campaignLink = result.data.getAddEventLeadLink;
      });
  }

  clickShare() {
    this.snackBarService.show("Copied to clipboard");
  }
}
